module.exports = "pegasus/assets/grayrect-facebook.png";